import { deactivateAllUsers } from "./DeactivateAllUsers";
import { deactivateUser } from "./deactivateUser";
import { reactivateUser } from "./reactiveUser";

export class UserManagement{
    courseId:number;
    wrapper:JQuery

    constructor(courseId, wrapper='.page-content'){
        this.courseId = courseId;
        this.wrapper = $(wrapper);
        this.addListeners();
    }


    addListeners(){
        const self = this;
        this.wrapper.on("click", ".deactivate-user", function(){
            const userId = $(this).attr('data-user');
            const button = $(this);
            deactivateUser(userId, self.courseId, button);
        })
        this.wrapper.on("click", ".reactivate-user", function(){
            const userId = $(this).data("user");
            const button = $(this);
            reactivateUser(userId, self.courseId, button);
        })
        this.wrapper.on("click", ".export-anonym-users", function(){
            exportAnonymousUsers(self.courseId);
        });
        this.wrapper.on("click", ".export-active-users", function(){
            exportActiveUsers(self.courseId);
        });
        this.wrapper.on("click", ".deactivate-all-users-from-course", function(){
            const confirmed = confirm("Sicher, dass du alle Schüler/-innen in diesem Kurs deaktivieren möchtest?");
            if (confirmed) {
                deactivateAllUsers(self.courseId, $(this));
            }
        });
        this.wrapper.on("click", ".go-to-abgabe", function(){
            const userId = $(this).attr('data-id');
            const courseId = $(this).attr('data-fach');
            window.open(pexam_ajax_object.site_url + '/abgaben/?userId='+userId+'&fach='+courseId);
        });
    }
}